import { SAVE_CARDS } from '../types';

import updateActive from './updateActive';
import preparePaymentCards from '../utility/preparePaymentCards';

const DOT = '\u2022';

export default function saveCards(cardsArr, mask = DOT) {
  return async (dispatch, getState) => {
    const {
      common: {
        cardSuggests: { activeCard },
      },
    } = getState();

    const preparedCards = preparePaymentCards(cardsArr, mask);

    if (!activeCard || !activeCard.id || !preparedCards.find(card => card.id === activeCard.id)) {
      const validCards = preparedCards.filter(card => !card.expired);
      dispatch(updateActive(validCards[0]));
    }

    dispatch({
      items: preparedCards,
      suggests: preparedCards,
      type: SAVE_CARDS,
    });
  };
}
